import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { MediaItem, fetchMediaData } from '../services/apiService';

const Home: React.FC = () => {
  const [photos, setPhotos] = useState<MediaItem[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const getPhotos = async () => {
      try {
        const { items } = await fetchMediaData(1, 9); // Fetch 9 images
        setPhotos(items);
        setIsLoading(false);
      } catch (err: unknown) {
        console.error('Error fetching photos:', err);
        setError('Error fetching photos. Please try again later.');
        setIsLoading(false);
      }
    };

    getPhotos();
  }, []);

  return (
    <div>
      {/* Hero Section */}
      <section className="bg-[#0c6081] text-white py-20 text-center">
        <div className="container mx-auto">
          <h1 className="text-4xl md:text-6xl font-bold">Daytocode</h1>
          <p className="text-lg md:text-xl font-light mt-4">
            Explore our journey through captivating photos and events.
          </p>
          <Link to="/photos" className="bg-[#f7b95d] text-white px-6 py-3 mt-6 inline-block rounded-lg shadow-lg hover:bg-[#f64f40]">
            Explore Gallery
          </Link>
        </div>
      </section>

      {/* Media Thumbnails Section */}
      <section className="py-12 bg-gray-100">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold text-center mb-8">Latest from Our Media</h2>
          {isLoading ? (
            <p className="text-center">Loading...</p>
          ) : error ? (
            <p className="text-center text-red-500">{error}</p>
          ) : (
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4">
              {photos.map((item) => (
                <div key={item.id} className="overflow-hidden rounded-lg shadow-md">
                  <img src={item.resizedImageUrl[0]} alt={item.caption || 'Media thumbnail'} className="object-cover w-full h-48" />
                </div>
              ))}
            </div>
          )}
          <div className="text-center mt-8">
            <Link to="/photos" className="bg-[#0c6081] text-white px-6 py-3 inline-block rounded-lg shadow-lg hover:bg-[#f7b95d]">
              View Full Gallery
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;
